<template>
  <!-- <pre class="text-black">{{ CssImageHelpers.imageProps(props.card?.backgroundMediaField?.data) }}</pre> -->
  <div
    class="overlay-card h-full"
    :style="[
      { minHeight: cardsGroup?.maxImageHeight ? `${cardsGroup.maxImageHeight}px` : '300px' },
      CssStyleHelpers.margins(cardsGroup.cardsOuterSpacing),
    ]"
  >
    <!-- Карточка с контентом -->
    <div
      class="overlay-card-content"
      :style="[
        { minHeight: cardsGroup?.maxImageHeight ? `${cardsGroup.maxImageHeight}px` : '300px' },
        CssStyleHelpers.background(
          props.card?.backgroundColorField?.data?.value,
          props.card?.backgroundColorToggleField?.data?.value
        ),
        CssStyleHelpers.backgroundImage(
          CssImageHelpers.imageProps(props.card?.backgroundMediaField?.data).imageSrc,
          props.card?.backgroundMediaToggleField?.data?.value,
        ),
        CssStyleHelpers.borderRadius(cardsGroup.cardsBorderRadius),
        CssStyleHelpers.border(
          props.card?.borderField?.data,
          props.card?.borderField?.data?.enabled
        ),
        CssStyleHelpers.paddings(cardsGroup.cardsInnerSpacing),
      ]"
    >
      <!-- Медиа секция як фон -->
      <div
        v-if="mainGroup.isShowCardMedia"
        class="overlay-card-media h-full overflow-hidden"
        :style="{
          ...CssStyleHelpers.filterShadow(props.card?.shadowField?.data),
          ...CssStyleHelpers.borderRadius(cardsGroup.imageBorderRadius),
          ...CssStyleHelpers.paddings(props.card?.mediaPaddingsField?.data),
        }"
      >
        <MediaCard
          :media-type="card?.mediaField?.type"
          :image-props="CssImageHelpers.imageProps(card.mediaField?.data)"
          :video-props="CssVideoHelpers.videoProps(card.mediaField?.data)"
          :mask-props="card?.maskField?.data"
          :object-fit="card?.mediaField?.data?.objectFit || 'contain'"
          :border-radius="card?.mediaField?.data?.borderRadius"
          class="h-full"
        />
      </div>

      <!-- Текстовая секция поверх медиа -->
      <div
        v-if="mainGroup.isShowCardText"
        class="overlay-card-text"
        :style="[
          CssStyleHelpers.background(
            props.card?.textBackgroundField?.data?.value,
            props.card?.textBackgroundToggleField?.data?.value
          ),
          CssStyleHelpers.paddings(cardsGroup.cardTextSpacing),
          CssStyleHelpers.borderRadius(props.card?.textBackgroundRadiusField?.data?.value ?? 0),
          CssStyleHelpers.filterShadow(props.card?.textBackgroundShadowField?.data),
        ]"
      >
        <TextCard :text="card?.textField?.data?.text" />
      </div>
      
    </div>
  </div>
</template>

<script setup lang="ts">
import MediaCard from "./MediaCard.vue";
import TextCard from "./TextCard.vue";
import {
  CssImageHelpers,
  CssStyleHelpers,
  CssVideoHelpers,
} from "../utils/cssStyleHelpers";

interface OverlayCardProps {
  // Данные карточки
  card: any;
  // Группа настроек карточек
  cardsGroup?: any;
  mainGroup?: any;
}

const props = defineProps<OverlayCardProps>();
</script>

<style scoped>
@reference "tailwindcss";
.overlay-card {
  @apply w-full min-h-full overflow-hidden;
}

.overlay-card-content {
  @apply w-full min-h-full overflow-hidden relative;
}

.overlay-card-media {
  @apply w-full absolute inset-0 z-0;
}

.overlay-card-text {
  @apply text-base leading-relaxed relative z-10 flex items-center justify-center min-h-full;
  /* background: rgba(0, 0, 0, 0.3); */
  /* backdrop-filter: blur(2px); */
}

/* Адаптивність для мобільних пристроїв */
@media (max-width: 768px) {
  .overlay-card-text {
    @apply text-sm;
  }
}
</style>

<style>
@reference "tailwindcss";
/* Добавляем базовые стили card-item для совместимости */
.overlay-card {
  @apply text-base leading-relaxed relative z-10 text-black;
}
</style>
